/**
 * PATH: packages/ui/src/components/settings/UsageTab.tsx
 * PURPOSE:
 *   Settings-modal "Usage" tab. Thin wrapper around `AiUsageDashboard` that
 *   provides the SettingsTab content slot expected by `buildSettingsTabs`.
 *
 * WHY: The user's directive was "create a proper usage section in settings
 *      with a separate page for this make sure it is structured as a
 *      library baseline" — the dashboard component is the page; this tab
 *      is the universal entry-point that every host app gets for free as
 *      soon as they pass an `aiUsageApi`.
 *
 *   Passes through the new `autoRefreshIntervalMs`, `autoRefreshDefaultOn`,
 *   and `onNewActivity` props so host apps can wire live updates +
 *   notification-bell push without re-implementing the dashboard.
 */

import { AiUsageDashboard, type AiUsageDashboardProps } from './AiUsageDashboard'

export interface UsageTabProps
  extends Omit<AiUsageDashboardProps, 'organisationId' | 'organisationName'> {
  organisationId: string | number | null | undefined
  organisationName?: string | null
}

export function UsageTab({
  organisationId,
  organisationName,
  ...rest
}: UsageTabProps) {
  if (!organisationId) {
    return (
      <div className="rounded-lg border border-dashed border-slate-200 dark:border-slate-800 p-8 text-center text-xs text-slate-500">
        Select an organisation to view AI usage.
      </div>
    )
  }
  return (
    <AiUsageDashboard
      organisationId={organisationId}
      organisationName={organisationName}
      {...rest}
    />
  )
}

export default UsageTab
